import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import IntegerField from '@shared/fields/integer-field';
import DateYearField from '@shared/fields/date-year-field';
import DateModelField from '@shared/fields/date-model-field';

function label(name) {
    return i18n(`entities.category.fields.${name}`);
}

const fields = ({ dateFormat, timeFormat, populateDate }) => ({
    id: new IdField('id', label('id')),
    name: new StringField('name', label('name'), { "required": true }),
    label: new StringField('label', label('label'), { "required": true }),
    index: new IntegerField('index', label('index'), { "required": true }),
    minBirthYear: new DateYearField('minBirthYear', label('minBirthYear'), { "required": true }),
    maxBirthYear: new DateYearField('maxBirthYear', label('maxBirthYear'), { "required": true }),
    minBirthDate: new DateModelField('minBirthDate', label('minBirthDate'), { "required": true, dateFormat, populateDate }),
    maxBirthDate: new DateModelField('maxBirthDate', label('maxBirthDate'), { "required": true, dateFormat, populateDate }),
    createdAt: new DateTimeField('createdAt', label('createdAt'), { dateFormat, timeFormat }),
    updatedAt: new DateTimeField('updatedAt', label('updatedAt'), { dateFormat, timeFormat}),
    createdAtRange: new DateTimeRangeField('createdAtRange', label('createdAtRange')),

});

export class CategoryModel extends GenericModel {
    constructor({ dateFormat, timeFormat, populateDate } = {}) {
        super();

        this.dateFormat = dateFormat;
        this.timeFormat = timeFormat;
        this.populateDate = populateDate;
    }

    fields() {
        const { dateFormat, timeFormat, populateDate } = this;
        return fields({ dateFormat, timeFormat, populateDate });
    }

    presenter(row, fieldName) {
        const fields = this.fields();

        if (!fields[fieldName]) {
            throw new Error(`${fieldName} not found`);
        }

        return fields[fieldName].forPresenter(
            row[fields[fieldName].name],
        );
    }
}